import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENV,
  enabled: !import.meta.env.DEV,
  tracesSampleRate: 0,
})
